import { Link } from "react-router-dom";
import { Anchor } from "lucide-react";

// Shared frame for the affiliate auth screens (login / verify / reset).
export const AffAuthFrame = ({ title, subtitle, children, testId }) => (
  <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6" data-testid={testId}>
    <div className="w-full max-w-md">
      <Link to="/affiliate" className="flex items-center gap-2 mb-8" data-testid="aff-auth-logo">
        <div className="w-7 h-7 rounded-md bg-ink text-white grid place-items-center"><Anchor className="h-4 w-4" /></div>
        <span className="font-display text-[17px] font-medium tracking-tight">Seavanto</span>
        <span className="text-xs text-emerald-700 font-semibold tracking-widest uppercase ml-1">Partners</span>
      </Link>
      <div className="rounded-2xl border border-zinc-200 bg-white p-6 lg:p-8 shadow-sm">
        <h1 className="font-display text-2xl font-medium tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-zinc-600 mt-1">{subtitle}</p>}
        <div className="mt-5">{children}</div>
      </div>
    </div>
  </div>
);
